import $ from "jquery";
var $lookupcompanytable = $('#lookupcompanytable');
var $lookupCompanyUrl = $('input[name=lookupCompanyUrl]').val();

export function checkoutLookupCompany (query, element, dataTable, callback) {
    $.post($lookupCompanyUrl, {
        "query": query,
        "__RequestVerificationToken": $("input[name=__RequestVerificationToken]").val()
    }, function (data) {
        dataTable.destroy();
        $(element).html(data);
        $lookupcompanytable.addClass('fade-in one');
        $lookupcompanytable.show();
        callback();
    });
}